import { Box } from "@mui/material";
import l10n from "../lib/l10n";
import { styled } from '@mui/material/styles';

const StyledBizLogoContainer = styled(Box, {
  name: 'BizLogo',
  slot: 'root'
})(({theme}) => ({
  display: "inline-flex",
  alignSelf: "center",
  padding: theme.spacing(0.5, 0), 
  // height: 0
}));

const StyledBizLogo = styled(Box, {
  name: 'BizLogo',
  slot: 'image'
})({
  margin: "auto",
  display: "inline-flex",
  height: 'auto',
  width: '100%',
  maxWidth: 280
});

function BizLogo(props) {
  const { ...restProps } = props;
  return (
    <>
      {l10n?.biz_logo && (
        <StyledBizLogoContainer>
          <StyledBizLogo
            component="img"
            alt={l10n.biz_logo.alt}
            src={l10n.biz_logo.src}
            {...restProps}
          />
        </StyledBizLogoContainer>
      )}
    </>
  );
};

export default BizLogo;
